import { useAuth } from '../context/AuthContext';

const ENV_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  Production: { bg: 'bg-red-700', text: 'text-white', label: 'PRODUCTION' },
  Staging: { bg: 'bg-orange-600', text: 'text-white', label: 'STAGING' },
  Development: { bg: 'bg-blue-700', text: 'text-white', label: 'DEVELOPMENT' }
};

export default function EnvBanner() {
  const { user } = useAuth();
  const env = user?.environment;
  if (!env) return null;
  const style = ENV_STYLES[env] ?? { bg: 'bg-neutral-700', text: 'text-white', label: env.toUpperCase() };

  return (
    <div className={`${style.bg} ${style.text} px-4 py-1 text-center text-xs font-semibold tracking-wide`}>
      {style.label}
    </div>
  );
}
